// export const API = process.env.REACT_APP_BACKEND;
export const API ='https://blogus-server-1.onrender.com/blogus'